import TelegramLoginButton from '../components/TelegramLoginButton';
import { getStoredRegUtm } from '../utils/regUtmStorage';
import './LoginPage.css';

export default function LoginPage({ onSuccess }) {
  // Для отладки: показываем что хранится в cookies/localStorage
  const storedUtm = getStoredRegUtm();

  return (
    <div className="login-page">
      {/* Отладочная надпись */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        padding: '4px 8px',
        fontSize: '10px',
        color: '#888',
        backgroundColor: 'rgba(0,0,0,0.05)',
        zIndex: 9999,
        wordBreak: 'break-all'
      }}>
        UTM: {storedUtm || 'null'}
      </div>

      <div className="login-content">
        <div className="login-picture">
          <img
            src="/login-picture.png"
            alt="Login Illustration"
            className="login-image"
          />
        </div>

        <h1 className="login-title">Добро пожаловать в Sense!</h1>

        <p className="login-description">
          Здесь игры становятся практикой, а вопросы помогают услышать себя и стать ближе c другими
        </p>

        <div className="login-telegram-container">
          <TelegramLoginButton onSuccess={onSuccess || (() => window.location.reload())} />
        </div>

        <div className="telegram-widget-anotation">
          Мы не получим доступ к вашим чатам<br />и номеру телефона
        </div>

        <p className="login-agreement">
          Нажимая кнопку выше, вы соглашаетесь с <a href="https://sense-games.ru/oferta" className="login-link">публичной офертой</a> и <a href="https://sense-games.ru/privacy" className="login-link">политикой персональных данных</a>
        </p>
      </div>
    </div>
  );
}
